<template>
  <section class="space-xxs pb-4 bg-transparent pt-4" v-if="!loading">
    <div class="container card box-shadow">
      <div class="row justify-content-center text-center section-intro" v-if="title">
        <div class="col-12 col-md-8 col-lg-7 pb-2">
          <h2 class="color-title pt-3">{{title}}</h2>
          <span class="lead" v-if="subtitle">
            {{subtitle}}
          </span>
        </div>
        <!--end of col-->
      </div>
      <!--end of row-->
      <div class="content-card">
        <slot></slot>
      </div>
      <!--end of container-->
    </div>
  </section>
  <div class="app-loader-container" v-else>
    <div class="app-loader">
      <BallPulseLoader
        color="#3AB982"
        margin="2px"
        size="20px"
        radius="2px"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SectionContentCard',
    props: {
      title: {
        type: String
      },
      subtitle: {
        type: String
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/SectionContentCard.vue